import React, { useState, useEffect, useLayoutEffect } from 'react';
// import { First, Second, Third, Fourth, Fifth } from '../../smart/utils/images-loader/ImagesLoader';
import { GalleryItem } from './GalleryItem';
// import { ServiceSelector } from '../../smart/utils/ServiceSelector';
import { Loader } from '../utils/loader/Loader';
import { Markup } from 'interweave';
import './galleryarea.scss';


type props = {}

export const GalleryArea = (props: any) => {

    const [isOnline, setIsOnline] = useState(false);
    // const myLoader = ServiceSelector.select(props.filename);
    console.log(props.filename, props.myLoader)
    useEffect(() =>

        setIsOnline(true), [setIsOnline]
    );

    if (isOnline === false) {
        return <Loader />;
    }
    else
        return  <div className="gallery_area">
        <div className="container">
            <div className="row">
                <div className="col-xl-12">
                    <div className="section_title text-center mb-50">
                        <h3>
                            <Markup content={props.contents.subtitle !== undefined ? props.contents.subtitle : ""} />
                        </h3>
                        <p style={{ whiteSpace: "pre-line" }}>
                            <Markup content={props.contents.p1 !== undefined ? props.contents.p1 : ""} />
                        </p>
                        {/* <br/>
                        <p style={{ whiteSpace: "pre-line" }}>
                            <Markup content={props.contents.p2 !== undefined ? props.contents.p2 : ""} />
                        </p> */}
                    </div>
                </div>
            </div>
                <div className="row grid d-flex justify-content-center">
                    {Object.entries(props.myLoader).map(([keyName, value],index) => {
                        if (index != Object.keys(props.myLoader).length - 1){
                            
                            return <GalleryItem key={index} {...props} filename={props.filename} index={index} serviceImg={value} clickhandler={props.clickhandler} />
                        }
                    })}
                {/* <div className="col-xl-4 col-lg-6 grid-item cat1 col-md-6">
                    <div className="single-gallery mb-20">
                        <div className="portfolio-img">
                            <img src={ImagesLoader.First} alt="" />
                        </div>
                        <div className="gallery_hover">
                            <a href="portfolio_details.html" className="hover_inner">
                                <h3>Product Branding</h3>
                                <span>Branding</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 col-lg-6 grid-item cat3 cat4 col-md-6">
                    <div className="single-gallery mb-20">
                        <div className="portfolio-img">
                                <img src={ImagesLoader.Second} alt="" />
                        </div>
                        <div className="gallery_hover">
                            <a href="portfolio_details.html" className="hover_inner">
                                <h3>Product Branding</h3>
                                <span>Branding</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 col-lg-6 grid-item cat4 col-md-6">
                    <div className="single-gallery mb-20">
                        <div className="portfolio-img">
                                <img src={ImagesLoader.Third} alt="" />
                        </div>
                        <div className="gallery_hover">
                            <a href="portfolio_details.html" className="hover_inner">
                                <h3>Product Branding</h3>
                                <span>Branding</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-xl-8 col-lg-6 grid-item cat2 col-md-6">
                    <div className="single-gallery mb-20">
                        <div className="portfolio-img">
                                <img src={ImagesLoader.Fourth} alt="" />
                        </div>
                        <div className="gallery_hover">
                            <a href="portfolio_details.html" className="hover_inner">
                                <h3>Product Branding</h3>
                                <span>Branding</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 col-lg-6 grid-item cat2 col-md-6">
                    <div className="single-gallery mb-20">
                        <div className="portfolio-img">
                                <img src={ImagesLoader.Fifth} alt="" />
                        </div>
                        <div className="gallery_hover">
                            <a href="portfolio_details.html" className="hover_inner">
                                <h3>Product Branding</h3>
                                <span>Branding</span>
                            </a>
                        </div>
                    </div>
                </div> */}
            </div>
            {/* <div className="row">
                <div className="col-xl-12">
                    <div className="More_Works_btn text-center">
                        <a className="boxed-btn3-green-2" href="/#">More Works</a>
                    </div>
                </div>
            </div> */}
            <div className="row">
                <div className="col-xl-8 offset-xl-2">
                    <div className="portfolio_details_content mt-50 mb-50 text-center">
                        {/* <h4>The Result</h4> */}
                        <p style={{ whiteSpace: "pre-line" }}>
                            <Markup content={props.contents.p2 !== undefined ? props.contents.p2 : ""} />
                        </p>
                        {/* <div className="live_view_btn mt-50">
                            <a href="/#" className="boxed-btn3-green-2">Live View</a>
                        </div> */}
                    </div>
                    <div className="portfolio_details_content mt-50 mb-50 text-center">
                        <h4><Markup content={props.contents.p30_title !== undefined ? props.contents.p30_title : ""} /></h4>
                        <p style={{ whiteSpace: "pre-line" }}>
                            <Markup content={props.contents.p30 !== undefined ? props.contents.p30 : ""} />
                        </p>
                        {/* <div className="live_view_btn mt-50">
                            <a href="/#" className="boxed-btn3-green-2">Live View</a>
                        </div> */}
                    </div>
                    <div className="portfolio_details_content mt-50 mb-50 text-center">
                        <h4><Markup content={props.contents.p31_title !== undefined ? props.contents.p31_title : ""} /></h4>
                        <p style={{ whiteSpace: "pre-line" }}>
                            <Markup content={props.contents.p31 !== undefined ? props.contents.p32 : ""} />
                        </p>

                        {/* <div className="live_view_btn mt-50">
                            <a href="/#" className="boxed-btn3-green-2">Live View</a>
                        </div> */}
                    </div>
                    <div className="portfolio_details_content mt-50 mb-50 text-center">
                        <h4><Markup content={props.contents.p32_title !== undefined ? props.contents.p32_title : ""} /></h4>
                        <p style={{ whiteSpace: "pre-line" }}>
                            <Markup content={props.contents.p32 !== undefined ? props.contents.p32 : ""} />
                        </p>
                        {/* <div className="live_view_btn mt-50">
                            <a href="/#" className="boxed-btn3-green-2">Live View</a>
                        </div> */}
                    </div>
                    <div className="portfolio_details_content mt-50 mb-50 text-center">
                        <h4><Markup content={props.contents.p33_title !== undefined ? props.contents.p33_title : ""} /></h4>
                        <p style={{ whiteSpace: "pre-line" }}>
                            <Markup content={props.contents.p33 !== undefined ? props.contents.p33 : ""} />
                        </p>
                        {/* <div className="live_view_btn mt-50">
                            <a href="/#" className="boxed-btn3-green-2">Live View</a>
                        </div> */}
                    </div>
                    <div className="portfolio_details_content mt-50 mb-50 text-center">
                        <h4><Markup content={props.contents.p34_title !== undefined ? props.contents.p34_title : ""} /></h4>
                        <p style={{ whiteSpace: "pre-line" }}>
                            <Markup content={props.contents.p34 !== undefined ? props.contents.p34 : ""} />
                        </p>
                        {/* <div className="live_view_btn mt-50">
                            <a href="/#" className="boxed-btn3-green-2">Live View</a>
                        </div> */}
                    </div>
                    <div className="portfolio_details_content mt-50 mb-50 text-center">
                        <h4><Markup content={props.contents.p35_title !== undefined ? props.contents.p35_title : ""} /></h4>
                        <p style={{ whiteSpace: "pre-line" }}>
                            <Markup content={props.contents.p35!== undefined ? props.contents.p35 : ""} />
                        </p>
                        {/* <div className="live_view_btn mt-50">
                            <a href="/#" className="boxed-btn3-green-2">Live View</a>
                        </div> */}
                    </div>
                    <div className="portfolio_details_content mt-50 mb-50 text-center">
                        <h4><Markup content={props.contents.p36_title !== undefined ? props.contents.p36_title : ""} /></h4>
                        <p style={{ whiteSpace: "pre-line" }}>
                            <Markup content={props.contents.p36 !== undefined ? props.contents.p36 : ""} />
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
